export default __webpack_public_path__ + "/dist/images/blog-icon.8ad117d9662b9c5ed6f8424a358bb990.svg";